import React from 'react';
import PropTypes from 'prop-types';
import { DEFAULT_VIDEO_SRC } from '../../constants';
import ExplanationVideo from '../../../../shared/components/ExplanationVideo';
import './index.scss';

const Header = ({ category }) => (
    <header>
        <img src={category.backgroundImage} className="category-image" alt={category.title}/>
        <div className="inner flex-center max-width-container equal-padding">
            <h1>{category.title}</h1>
            <p className="subtitle">{category.subtitle}</p>
            <ExplanationVideo hasVideoLink={false}
                subcategoryName={'test'}
                isCategoryPage
                src={DEFAULT_VIDEO_SRC}/>
        </div>
    </header>
);

Header.propTypes = {
    category: PropTypes.object
};

export default Header;